import { keyframes } from '@emotion/react';

const spinClockwise = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(359deg);
  }
`;

const spinCounterclockwise = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-359deg);
  }
`;

const pulse = keyframes`
  0% {
    opacity: .6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: .6;
  }
`;

const unBlur = keyframes`
  0% {
    filter: blur(4px);
  }
  100% {
    filter: blur(0px);
  }
`;

export { spinClockwise, spinCounterclockwise, pulse, unBlur };
